export type VersionLevel = 'patch' | 'minor' | 'major'

/**
 * Compares two semver strings and returns the level of difference.
 * Returns null if the versions are the same.
 */
export function getVersionLevel(current: string, latest: string): VersionLevel | null {
  const currentParts = current.split('.').map(Number)
  const latestParts = latest.split('.').map(Number)

  const [curMajor = 0, curMinor = 0, curPatch = 0] = currentParts
  const [latMajor = 0, latMinor = 0, latPatch = 0] = latestParts

  if (curMajor !== latMajor) return 'major'
  if (curMinor !== latMinor) return 'minor'
  if (curPatch !== latPatch) return 'patch'
  return null
}

/**
 * Checks whether a project part has stored calculated results.
 */
export function hasStoredResults(part: Record<string, unknown>): boolean {
  const cr = part?.calculatedResults as Record<string, unknown> | undefined
  if (!cr) return false
  const results = cr.results as Record<string, unknown> | undefined
  return !!results && Object.keys(results).length > 0
}
